"use client";

import React, { useMemo } from "react";
//  @ts-ignore
import FileViewer from "react-file-viewer";

import { getFileExtentionFromName } from "@/utils/files";

import { StyledContainer } from "./FilePreviewer.styles";
import { IFilePreviewerProps } from "./FilePreviewer.types";

const FilePreviewer: React.FC<IFilePreviewerProps> = ({
  url,
  className,
  extention: extentionFromProps,
}) => {
  const extention = useMemo(
    () => extentionFromProps || getFileExtentionFromName(url),
    [extentionFromProps, url]
  );

  return (
    <StyledContainer className={className}>
      <FileViewer fileType={extention} filePath={url} />
    </StyledContainer>
  );
};

export default FilePreviewer;
